<template>
    <section class="progressBar-wrapper">
        <b-dropdown
            :mobile-modal="false"
            :triggers="['hover']"
            aria-role="list"
            class="competitionInfo"
            position="is-bottom-left"
            @active-change="state => (this.isActive = state)">
            <template #trigger>
                <div class="flex is-align-items-center progressBar-container">
                    <div class="progressBar mr-1">
                        <div style="border-radius: 30px; height: 100%; overflow: hidden">
                            <div class="progressBar-icon-left">
                                <img
                                    alt="logo-header"
                                    :src="ratingImg">
                            </div>
                            <div
                                class="progressBar-line"
                                :style="{ width: `${ percentGoal }%`, 'max-width': '100%' }">
                                <span
                                    v-if="percentGoal"
                                    class="progressBar-amountPercent">
                                    {{ percentGoal }}%
                                </span>
                                <div class="progressBar_bullet"></div>
                            </div>
                            <span class="progressBar-bg"></span>
                        </div>
                    </div>
                    <span class="count">
                        {{ place }}
                    </span>
                    <img
                        :class="['ml-1 mr-1', { 'is-desc': isActive }]"
                        alt="check-mark"
                        src="@/assets/Competition/Raffle/check-mark.svg">
                </div>
            </template>

            <div class="competitionInfo-wrapper has-text-white">
                <div class="competitionInfo-body">
                    <div class="flex is-justify-content-space-between">
                        <div class="flex is-align-items-center">
                            <img
                                alt="coin"
                                class="mr-2 competitionInfo-content_logo"
                                style="width: 48px; height: 48px;"
                                :src="ratingImg">
                            <div>
                                <p class="is-size-3 has-text-weight-semibold competitionInfo__place">
                                    {{ place }}
                                </p>
                                <p class="subtitle-style-text">
                                    {{ $t("webmaster.dashboard.competition.dropdown.place") }}
                                </p>
                            </div>
                        </div>

                        <div class="flex is-flex-direction-column is-align-items-flex-end">
                            <div class="flex is-align-items-center">
                                <img
                                    alt="coin"
                                    class="mr-3"
                                    src="@/assets/Competition/Raffle/dropdown/bullets.svg">
                                <div>
                                    <div class="is-align-items-center is-justify-content-flex-end">
                                        <template v-if="isFulfilledConditions">
                                            <p class="is-size-3 has-text-weight-semibold has-text-white competitionInfo__place">
                                                {{ currentCompetition.balance }}
                                            </p>
                                        </template>
                                        <template v-else>
                                            <span class="current-progress">
                                                {{ currentCompetition.balance }}
                                            </span>
                                            <span class="current-progress">
                                                /
                                                {{ floatGoal }}
                                            </span>
                                        </template>
                                    </div>
                                    <p class="subtitle-style-text">
                                        {{ $t("webmaster.dashboard.competition.dropdown.bullets") }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <img
                        alt="coin"
                        class="competitionInfo-body_line"
                        src="@/assets/Competition/Raffle/dropdown/line.svg">

                    <div class="flex">
                        <img
                            alt="cross"
                            class="mr-2 mt-1"
                            style="height: fit-content"
                            src="@/assets/Competition/Raffle/dropdown/cross.svg">
                        <p class="competitionInfo-body_description">
                            {{ $t("webmaster.dashboard.competition.dropdown.info.participants") }}
                        </p>
                    </div>

                    <div class="flex">
                        <img
                            alt="cross"
                            class="mr-2 mt-1"
                            style="height: fit-content"
                            src="@/assets/Competition/Raffle/dropdown/cross.svg">
                        <p class="competitionInfo-body_description">
                            {{ $t("webmaster.dashboard.competition.dropdown.info.traffic") }}
                        </p>
                    </div>

                    <div class="flex">
                        <img
                            alt="cross"
                            class="mr-2 mt-1"
                            style="height: fit-content"
                            :src="imageSrc(isFulfilledConditions ? 'check' : 'cross')">
                        <p
                            class="competitionInfo-body_description"
                            :class="{ 'has-text-white': isFulfilledConditions }">
                            <i18n :path="`webmaster.dashboard.competition.dropdown.info.${ isFulfilledConditions ? 'fulfilledConditions' : 'conditions' }`">
                                <template #count>
                                    <span class="has-text-white">{{ floatGoal }}+</span>
                                </template>
                            </i18n>
                        </p>
                    </div>

                    <div class="flex mb-1">
                        <img
                            alt="cross"
                            class="mr-1 mt-2 competitionInfo-body_about-img"
                            style="height: fit-content"
                            src="@/assets/Competition/Raffle/dropdown/bullet.svg">
                        <p class="competitionInfo-body_about-competition">
                            {{ $t("webmaster.dashboard.competition.dropdown.info.footer") }}
                        </p>
                    </div>
                </div>
            </div>
        </b-dropdown>
    </section>
</template>

<script>
  import { mapState } from "vuex";
  import { GET_CURRENT_COMPETITION } from "@core/store/action-constants";
  import { encodeFilters, formatPercent, toFixed } from "@core/filters";

  export default {
    name: "CompetitionDropdown",

    data () {
      return {
        isActive: false
      };
    },

    computed: {
      ...mapState("competition", {
        currentCompetition: ({ currentCompetition }) => currentCompetition,
        place: ({ currentCompetition }) => currentCompetition.place || "-"
      }),

      floatGoal () {
        return 350;
      },

      isFulfilledConditions () {
        // return this.currentCompetition.currentProgress >= (this.currentCompetition.floatGoal || this.floatGoal);
        return this.currentCompetition.balance >= this.floatGoal;
      },

      percentGoal () {
        if (this.currentCompetition) {
          return formatPercent(toFixed(
            /* this.currentCompetition.currentProgress / (this.currentCompetition.floatGoal || this.floatGoal)*/
            this.currentCompetition.balance / this.floatGoal,
            1)) || 0;
        } return 0;
      },

      isLoading () {
        return this.$wait(`competition/${ GET_CURRENT_COMPETITION }`);
      },

      ratingImg () {
        const value = { 1: "avatar-1.png", 2: "avatar-2.png", 3: "avatar-3.png", default: "scull.png" };
        return require(`@/assets/Competition/Raffle/dropdown/${ !this.isFulfilledConditions ? value.default : value[this.place] ?? value.default }`);
      }
    },

    methods: {
      encodeFilters,

      imageSrc (value) {
        return require(`@/assets/Competition/Raffle/dropdown/${ value }.svg`);
      }
    }
  };
</script>

<style lang="scss" scoped>
@import "~@/scss/competition-banner";

::v-deep {
    .dropdown .dropdown-menu {
        right: -70px !important;
    }
}

.current-progress {
  font-weight: 600;
  font-size: 18px;
  line-height: 170%;

  &:last-child {
    margin-left: 2px;
    color: $light-gray_;
  }
}

.subtitle-style-text {
  text-align: right;
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
  color: $light-gray_;
}

.is-desc {
  transform: rotate(180deg);
}

.progressBar {
    position: relative;
    width: 148px;
    height: 32px;

    background-color: black;
    border-radius: 60px;
    padding: 4px 4px 4px 18px;

    &-container {
      display: flex;
      align-items: center;

      padding-right: 4px;
      background-color: black;
      border-radius: 60px;
    }

    &_bullet {
      display: block;
      height: 100%;
      margin: 0 8px;
      background: url("~@/assets/Competition/Raffle/dropdown/vertical-bullets.svg") no-repeat;
      background-position-y: 50%;
    }

    &:hover .progressBar-amountPercent {
        display: block;
    }

    &-icon-left {
        position: absolute;
        z-index: 3;
        top: 50%;
        transform: translateY(-50%);
        left: -20%;

        height: 48px;
        width: 48px;

        display: flex;
        align-items: center;
        justify-content: center;

        border-radius: 999px;
        background-color: black;
    }

    &-bg {
        $dark-gray: #333333;
        position: absolute;
        top: 50%;
        left: 55%;
        transform: translate(-50%, -50%);
        z-index: 1;

        height: calc(100% - 8px);
        width: 84%;

        border-radius: 60px;
        background-color: $dark-gray;
    }

    &-line {
        position: relative;
        z-index: 2;
        height: 100%;
        border-radius: 60px;
        background: $main-color;

        .progressBar-amountPercent {
            display: none;

            position: absolute;
            top: -113%;
            right: -20%;
            padding: 2px 5px;
            z-index: 11;

            font-weight: 600;
            font-size: 10px;
            line-height: 1.4;
            color: #FFFFFF;

            background-color: black;
            border-radius: 8px;
        }
    }
}

.default-text-style {
    color: $light-gray_;
    font-size: 14px;
    line-height: 1.5;
    white-space: pre;
}

.count {
  font-weight: 600;
  font-size: 20px;
  color: $main-color;
  line-height: 1;
}

.progressBar-wrapper {
    display: flex;
    align-items: center;
    height: 100%;
    margin-left: 0.5rem;
}

.competitionInfo {
    $self: &;
    $border-radius: 10px;
    $inner-indent: 10;

    &__place {
      line-height: 1;
      color: $main-color;
    }

    ::v-deep {
        .dropdown-content {
            padding: 0;
            border-radius: $border-radius;
        }

        .dropdown-menu {
            position: absolute;
            left: -50px;

            padding-top: #{ $inner-indent }px;
            border-radius: $border-radius;

            &::before {
                content: "";

                position: absolute;
                right: 0;
                bottom: 0;
                left: 0;

                width: 100%;
                height: calc(100% - #{ $inner-indent }px);

                border-radius: $border-radius;
                box-shadow: 0 4px 4px 0 #25062C40;
            }
        }
    }

    &-wrapper {
        position: relative;

        overflow: hidden;
        border-radius: $border-radius;
        background-color: black;

        #{ $self }-body {
            position: relative;
            width: 350px;

            padding: 32px;
            border-radius: $border-radius;

            &::before {
                content: "";
                position: absolute;
                right: 0;
                bottom: 0;

                width: 110px;
                height: 202px;
                background-image: url("~@/assets/Competition/Raffle/dropdown/spot.svg");
                background-size: cover;
                background-repeat: no-repeat;
                background-position: right;
            }

            &_line {
                display: block;

                width: 100%;
                margin: 18px 0 22px;
            }

            &_description {
                margin-bottom: 24px;

                color: $light-gray;
                font-weight: 400;
                font-size: 14px;
                line-height: 129%;
            }

            &_about-competition {
                font-size: 14px;
                line-height: 1.43;
                color: $main-color;
                white-space: pre-wrap;
            }
        }
    }
}

.dropdown-wrapper {
    display: flex;
    align-items: center;
    height: 100%;
    margin-left: 2rem;
}
</style>
